<template>
    <div>
        <div id="chart">
            <vue-apex-charts :height="height" :width="width" type="radialBar" :options="chartOptions"
                             :series="percentScore"></vue-apex-charts>
        </div>
    </div>
</template>

<script>
    import VueApexCharts from 'vue-apexcharts';

    export default {
        name: 'CreditScoreChart',
        components: {
            VueApexCharts,
        },
        props: {
            score: Number,
            height: String,
            width: String,
            size: String
        },
        data() {
            const hollow = {
                normal: { margin: 0, size: "65%" },
                small: { margin: 0, size: "55%", background: '#fafafa' },
                'x-small': { margin: 0, size: "48%", background: '#fafafa' }
            };
            const dataLabels = {
                normal: {
                    name: {
                        color: "#202020",
                        show: true,
                        offsetY: 45,
                        fontSize: '24px',
                        fontFamily: 'Fira Sans Condensed',
                    },
                    value: {
                        color: "#202020",
                        show: true,
                        offsetY: -10,
                        fontSize: '56px',
                        fontFamily: 'Fira Sans Condensed',
                        formatter: () => this.formattedScore,
                    }
                },

                small: {
                    name: {
                        color: "#202020",
                        show: true,
                        offsetY: 30,
                        fontSize: '18px',
                        fontFamily: 'Fira Sans Condensed',
                    },
                    value: {
                        color: "#202020",
                        show: true,
                        offsetY: -10,
                        fontSize: '38px',
                        fontFamily: 'Fira Sans Condensed',
                        formatter: () => this.formattedScore,
                    }
                },

                'x-small': {
                    name: {
                        color: "#202020",
                        show: true,
                        offsetY: 20,
                        fontSize: '12px',
                        fontFamily: 'Fira Sans Condensed',
                    },
                    value: {
                        color: "#202020",
                        show: true,
                        offsetY: -10,
                        fontSize: '24px',
                        fontFamily: 'Fira Sans Condensed',
                        formatter: () => this.formattedScore,
                    }
                }
            };

            return {
                chartOptions: {
                    chart: {
                        height: 280,
                        type: "radialBar",
                    },
                    colors: ["#20E647"],
                    plotOptions: {
                        radialBar: {
                            hollow: this.size
                                ? hollow[this.size]
                                : hollow['normal'],
                            startAngle: -120,
                            endAngle: 120,
                            dataLabels: this.size
                                ? dataLabels[this.size]
                                : dataLabels['normal']
                        }
                    },
                    fill: {
                        type: "gradient",
                        gradient: {
                            shade: "dark",
                            type: "vertical",
                            gradientToColors: ["#87D4F9"],
                            stops: [0, 100]
                        }
                    },
                    stroke: {
                        lineCap: "round"
                    },
                    labels: [this.$t('credit_score.points')]
                }
            }
        },
        computed: {
            percentScore() {
                return [this.score ? Math.round(this.formattedScore / 10) : 0];
            },
            formattedScore() {
                return this.score ? this.score : 0;
            },
        }

    }
</script>
